export default __webpack_public_path__ + "3838ed503beb31b23158b55ee1306f4c.svg";